import { render, staticRenderFns } from "./AdmissionConsult.vue?vue&type=template&id=f130da1e&scoped=true"
import script from "./AdmissionConsult.vue?vue&type=script&lang=js"
export * from "./AdmissionConsult.vue?vue&type=script&lang=js"
import style0 from "./AdmissionConsult.vue?vue&type=style&index=0&id=f130da1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f130da1e",
  null
  
)

export default component.exports